module.exports = __webpack_public_path__ + "static/media/E701.56120749.png";